import { Slider } from "./style";

export default Slider;
